import api from '@/api'

export default {
  fetch (page = 1) {
    return api.get('/users/me/notifications', { params: { page } })
  },

  read (id) {
    return api.put(`/users/me/notifications/${id}`, {
      read: true
    })
  },

  readAll () {
    return api.put('/users/me/notifications/all')
  }
}
